import { UAParser } from 'ua-parser-js';

export default function useUserAgent() {
  const parser = new UAParser(navigator.userAgent);

  const {
    ua,
    browser: { name = '', version = '' },
    device: { vendor = '', type = 'Desktop' },
  } = parser.getResult();

  return {
    ua,
    browserName: name,
    browserVersion: version,
    deviceName: vendor,
    deviceType: type,
  };
}
